<template>
  <div class="border-t border-t-grey-light-01">
    <button
      class="flex w-full items-center py-24 text-lg uppercase focus-visible:bg-grey-light-03"
      @click="isOpen = !isOpen"
    >
      <span>{{ facetLabel }}</span>
      <SpriteSymbol
        name="plus"
        class="pointer-events-none ml-auto mr-6 h-24 w-24 transition"
        :class="{ 'rotate-45': isOpen }"
      />
    </button>
    <TransitionHeight opacity>
      <div v-if="isOpen">
        <div
          v-if="isColor"
          class="grid grid-cols-[repeat(4,auto)] justify-between gap-8 pb-28 md:grid-cols-[repeat(6,auto)] md:gap-24"
        >
          <ProductFinderFacetTermColor
            v-for="term in terms"
            :key="term.filter"
            v-model="selected"
            :facet-id="facetId"
            v-bind="term"
          />
        </div>
        <div v-else class="grid gap-x-8 pb-28 md:grid-cols-2">
          <InputCheckbox
            v-for="term in terms"
            :key="term.filter"
            v-model="selected"
            :name="facetId + term.filter"
            :title="term.filter"
            :disabled="!term.count"
            :value="term.filter"
          />
        </div>
      </div>
    </TransitionHeight>
  </div>
</template>

<script lang="ts" setup>
import { FacetType, type FacetValueFragment } from '#graphql-operations'

defineOptions({
  name: 'ProductFinderFacet',
})

const props = withDefaults(
  defineProps<{
    facetId: string
    facetLabel: string
    facetType: FacetType
    terms?: FacetValueFragment[]
    initialOpen?: boolean
  }>(),
  {
    terms: () => [],
  },
)

const selected = defineModel<string[]>({
  default: () => [],
})

// If at least one term is selected the accordion should be open by default.
const isOpen = ref(!!selected.value.length || props.initialOpen)

// @TODO: Either let backend provide this information or hardcode a list of facet IDs here.
const isColor = computed(() => props.facetType === 'color')
</script>
